<template>
  <div>
    <div class="bg3" :style="{height:height}"></div>
    <div class="bg2">
      <div class="container">
        <div class="row">
          <div class="headline">
            <div class="title">战疫过后 大势所趋</div>
            <div class="sub-title">政策引导下的医疗新风口</div>
          </div>
          <div
            class="con"
          >2020年3月10日,习主席在湖北省考察疫情防控工作时提出:把疫情防控中催生的新业态新模式加快壮大起来,加大公共服务、应急物资保障等领域投入,加快数字经济、生物医药、医疗器械生命健康等产业发展。</div>
        </div>

        <div class="new">
          <img class="img-100" src="@/assets/img/xiangmu/new.png" alt srcset />
        </div>
      </div>
    </div>

    <div class="bg2 bg4">
      <div class="container">
        <div class="row">
          <div class="headline">
            <div class="title">雾化患者何去何从？</div>
            <div class="sub-title">家庭雾化已成为刚需风口</div>
          </div>
          <div
            class="con"
          >为了雾化患者能够更加及时有效的家庭雾化治疗，减少院内雾化交叉感染，尤其是当下新冠肺炎疫情期间，传播途径含气溶胶传播，医院雾化室是气溶胶传播最高风险场所之一，因此家庭雾化治疗是雾化业务的强需求。</div>
        </div>

        <div class="new">
          <img class="img-100" src="@/assets/img/xiangmu/bg4.png" alt srcset />
        </div>
      </div>
    </div>

    <div class="bg2 bg5">
      <div class="container">
        <div class="row">
          <div class="headline">
            <div class="title">物联网雾化站解决方案</div>
            <div class="sub-title">布咳乐雾化站项目</div>
          </div>
          <div
            class="con"
          >未来医疗通过将大数据与雾化器结合，推出了新零售模式的“布咳乐雾化站”项目，以柜为店，利用物联网设备和互联网技术把零散的传统雾化器租售业务标准化，帮助医院开展物联网家庭雾化新零售业务。</div>
        </div>

        <div class="new">
          <img class="img-100" src="@/assets/img/xiangmu/bg5.png" alt srcset />
        </div>
      </div>
    </div>

    <div class="bg4">
      <div class="container">
        <div class="row icon-list">
          <div class="col-md-4">
            <div class="flex icon-item">
              <img class="img" src="@/assets/img/xiangmu/icon (1).png" alt srcset />
              <span>24小时营业</span>
            </div>
          </div>

          <div class="col-md-4">
            <div class="flex icon-item">
              <img class="img" src="@/assets/img/xiangmu/icon (2).png" alt srcset />
              <span>监测家庭雾化数据</span>
            </div>
          </div>

          <div class="col-md-4">
            <div class="flex icon-item">
              <img class="img" src="@/assets/img/xiangmu/icon (3).png" alt srcset />
              <span>可选顺丰代还</span>
            </div>
          </div>

          <div class="col-md-4">
            <div class="flex icon-item">
              <img class="img" src="@/assets/img/xiangmu/icon (4).png" alt srcset />
              <span>无需现金交易</span>
            </div>
          </div>

          <div class="col-md-4">
            <div class="flex icon-item">
              <img class="img" src="@/assets/img/xiangmu/icon (5).png" alt srcset />
              <span>有效降低耗占比</span>
            </div>
          </div>

          <div class="new">
            <img class="img-100" src="@/assets/img/xiangmu/bg6.png" alt srcset />
          </div>
        </div>
      </div>
    </div>

    <div class="bg2 bg5">
      <div class="container">
        <div class="row">
          <div class="headline">
            <div class="title">使用流程</div>
          </div>
        </div>

        <video controls controlslist="nodownload" class="d-none d-lg-block video">
          <source src="@/assets/video/liucheng.mp4" type="video/mp4" />
        </video>

        <div class="new">
          <img class="img-100" src="@/assets/img/xiangmu/liucheng.png" alt srcset />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: ""
    };
  },
  beforeMount() {
    const that = this;
    var w = document.documentElement.clientWidth || document.body.clientWidth;
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    if (w > 992) {
      that.height = h - 80 + "px";
    } else {
      that.height = h / 2 + "px";
    }
    window.onresize = () => {
      var w = document.documentElement.clientWidth || document.body.clientWidth;
      var h =
        document.documentElement.clientHeight || document.body.clientHeight;
      if (w > 992) {
        that.height = h - 80 + "px";
      } else {
        that.height = h / 2 + "px";
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.bg3 {
  background-color: transparent;
  background-image: url("../../assets/img/xiangmu/bg3.png");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.bg2 {
  background-color: transparent;
  background-image: url("../../assets/img/xiangmu/bg2.png");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  padding-bottom: 70px;

  .headline {
    width: 100%;
    text-align: center;

    .title {
      font-size: 48px;
      padding: 70px 0 20px 0;
    }

    .sub-title {
      font-size: 26px;
    }
  }

  .con {
    font-size: 16px;
    text-align: center;
    padding: 50px 0 0 0;
    letter-spacing: 2px;
  }

  .new {
    width: 60%;
    margin-left: 20%;
  }
}

.bg4,
.bg5 {
  background-image: none !important;
  background-color: #fff;
}

.bg4 {
  background-color: #f5f5f5;
}

.bg5 {
  position: relative;
  .video {
    width: 300px;
    position: absolute;
    right: 10px;
    bottom: 10px;
  }
}

.icon-list {
  padding: 60px;

  .icon-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 30px;

    .img {
      width: 58px;
    }

    span {
      margin-left: 20px;
    }
  }

  .new {
    width: 60%;
    margin-left: 20%;
  }
}

@media (max-width: 576px) {
  .bg2 {
    .headline {
      width: 100%;
      text-align: center;

      .title {
        font-size: 24px;
        padding: 20px 0 20px 0;
      }
      .sub-title {
        font-size: 16px;
      }
    }

    .con {
      font-size: 14px;
      text-align: center;
      padding: 20px 40px;
    }

    .new {
      width: 80%;
      margin-left: 10%;
      margin-top: 0;
    }
  }
}
</style>